

export const index = 6;
export const component = async () => (await import('../entries/pages/services/_page.svelte.js')).default;
export const file = '_app/immutable/components/pages/services/_page.svelte-361a8f03.js';
export const imports = ["_app/immutable/components/pages/services/_page.svelte-361a8f03.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/index-ec171f57.js","_app/immutable/chunks/stores-115c3e61.js","_app/immutable/chunks/singletons-56d9a26f.js","_app/immutable/chunks/CardText-ab5fbb94.js"];
export const stylesheets = ["_app/immutable/assets/CardText-ccb86115.css"];
